import {
  ATTENTION_ORDER,
  needsAttention,
  type AttentionSeverity,
} from './needsAttention.ts';

/** How many open findings ask for attention, and the worst of them. */
export interface Attention {
  count: number;
  severity: AttentionSeverity;
}

/** Null when none of these severities is worth a mark. */
export function attentionOf(severities: readonly string[]): Attention | null {
  const marked = severities.filter(needsAttention);
  if (marked.length === 0) return null;

  const severity = ATTENTION_ORDER.find((rung) => marked.includes(rung))!;
  return { count: marked.length, severity };
}
